module.exports = __webpack_public_path__ + "img/bt4.d77f2b42.png";